import { render } from "./ClientArhive.vue?vue&type=template&id=356a9b6b"
import script from "./ClientArhive.vue?vue&type=script&lang=js"
export * from "./ClientArhive.vue?vue&type=script&lang=js"

import "./ClientArhive.vue?vue&type=style&index=0&id=356a9b6b&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__